
const UserId = (state) => state.UserId;
const User = (state) => state.User;
const TotalInfo = (state) => state.TotalInfo;
export default { UserId, User, TotalInfo }